<template>
  <MainLayout class="container mx-auto">
    <SceneTitle class="mt-10">
      키오스크
      <template slot="description">
        연습하고 싶은 키오스크를 선택해 주세요
      </template>
    </SceneTitle>

    <div class="pb-64">
      <div class="flex">
        <div class="w-1/2">
          <router-link to="/games/jongrogu/scenario">
            <div class="p-4" data-type="button">
              <BaseImg src="/logos/jg.png" alt="jongrogu" class="mx-auto" />
              <div class="mt-3 text-2xl font-bold text-center sm:text-3xl">종로구</div>
            </div>
          </router-link>
        </div>
        <div class="w-1/2">
          <router-link to="/games/nonghyup/scenario">
            <div class="p-4" data-type="button">
              <BaseImg src="/logos/nh.png" alt="nonghyup" class="mx-auto" />
              <div class="mt-3 text-2xl font-bold text-center sm:text-3xl">농협</div>
            </div>
          </router-link>
        </div>
      </div>

      <div class="flex">
        <div class="w-1/2">
          <router-link to="/games/burgerking/scenario">
            <div class="p-4" data-type="button">
              <BaseImg src="/logos/bk.png" alt="burgerking" class="mx-auto" />
              <div class="mt-3 text-2xl font-bold text-center sm:text-3xl">버거킹</div>
            </div>
          </router-link>
        </div>
        <div class="w-1/2">
          <router-link to="/games/lotteria/scenario">
            <div class="p-4" data-type="button">
              <BaseImg src="/logos/lt.png" alt="lotteria" class="mx-auto" />
              <div class="mt-3 text-2xl font-bold text-center sm:text-3xl">롯데리아</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import appConfig from '@src/app.config'
import MainLayout from '@layouts/main-layout.vue'
import SceneTitle from '@components/game/scene-title.vue'

export default {
  page: {
    title: appConfig.title,
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { SceneTitle, MainLayout },
}
</script>
